{
  "EMOJI": {
    "PLACEHOLDER": "Hledat emoji",
    "NOT_FOUND": "Nenalezeny žádné emoji odpovídající vašemu hledání",
    "REMOVE": "Odebrat"
  }
}